import { render, staticRenderFns } from "./EditorBase.vue?vue&type=template&id=673786c3&"
import script from "./EditorBase.vue?vue&type=script&lang=js&"
export * from "./EditorBase.vue?vue&type=script&lang=js&"
import style0 from "./EditorBase.vue?vue&type=style&index=0&id=673786c3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports